import { State, Action, StateContext, Selector } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { ImportStateModel, OrderReviewResponse } from './model/import-state.model';
import {
	SetCurrentGridPage,
	SetIsImportingOrder,
	SetIflagSoftDelete
} from './action/import.action';
import { ImportOrderService } from '../service/import-order.service';
import { Logout } from '@cv-invision/core';
import { Injectable } from '@angular/core';

@State<ImportStateModel>({
	name: 'import',
	defaults: {
		currentGridPage: {
			data: [],
			totalCount: 0,
			offset: 0,
			limit: 10
		},
		isImportingOrder: null
	}
})
@Injectable()
export class ImportState {
	constructor(private importOrderService: ImportOrderService) {}

	/**
	 * Get Current Photo Review Collection.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getImportGridCollection(state: ImportStateModel): OrderReviewResponse {
		return state.currentGridPage;
	}

	/**
	 * get whether an order is being imported.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getIsImportingOrder(state: ImportStateModel): boolean {
		return state.isImportingOrder;
	}

	/**
	 * get whether an previous order should be delete.
	 * @param state: InboxStateModel
	 */
	@Selector()
	static getIsSofDelete(state: ImportStateModel): boolean {
		return state.sofDelete;
	}

	/**
	 *    set the photos for the current order
	 * @param ctx
	 * @param orderId
	 */
	@Action(SetCurrentGridPage)
	setCurrentGridPage(ctx: StateContext<ImportStateModel>, { page }: SetCurrentGridPage): any {
		return this.importOrderService.getOrdersReview(page).pipe(
			tap(result => {
				const store = ctx.getState();
				const currentGridPage = result;
				ctx.patchState({
					...store,
					currentGridPage
				});
			})
		);
	}

	/**
	 * set the isImporting value
	 * @param ctx
	 * @param isImportingOrder
	 */
	@Action(SetIsImportingOrder)
	setIsImportingOrden(
		ctx: StateContext<ImportStateModel>,
		{ isImportingOrder }: SetIsImportingOrder
	): any {
		const store = ctx.getState();
		ctx.patchState({
			...store,
			isImportingOrder
		});
	}

	/**
	 * set whether the order should delete the duplciate orders
	 *
	 * @param ctx
	 * @param sofDelete
	 */
	@Action(SetIflagSoftDelete)
	setIflagSoftDelete(ctx: StateContext<ImportStateModel>, { sofDelete }: SetIflagSoftDelete): any {
		const store = ctx.getState();
		ctx.patchState({
			...store,
			sofDelete
		});
	}

	/**
	 * Logout.
	 * @param ctx: InboxStateModel
	 */
	@Action(Logout)
	logout(ctx: StateContext<ImportStateModel>): void {
		ctx.setState({});
	}
}
